import React from 'react';
import PropTypes from 'prop-types';

const Option = ({ name, onClickHandler, value }) => (
  <p onClick={() => onClickHandler(value)}>{name}</p>
);

Option.propTypes = {
  name: PropTypes.string,
  onClickHandler: PropTypes.func,
  value: PropTypes.string,
};
Option.defaultProps = {
  name: '',
  onClickHandler: (value) => {},
  value: '',
};

export { Option };



// WEBPACK FOOTER //
// ./react/components/Select/Option.jsx